import { types as t } from 'mobx-state-tree';
import { MarkBold } from './Mark/mark-bold.store';
import { MarkHighlightMultipleColor } from './Mark/mark-highlight-multiple-color.store';

export const SlateNode = t.model('SlateNode', {
  text: t.optional(t.maybeNull<any>(t.string), ''),
  ideaBold: t.maybeNull(MarkBold),
  bold: t.maybeNull(t.boolean),
  highlightMultipleColor: t.maybeNull(MarkHighlightMultipleColor),
});
